export { default } from './SingleClickHoldsStatusButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SingleClickHoldsStatusButton/index.js